import type { SiteNotification } from "@js/types/notifications";

export const isSiteNotificationNew = (
  siteNotification: SiteNotification,
): boolean => {
  return !siteNotification.read || !!siteNotification.forceUnread;
};
